import {createAction, props} from '@ngrx/store';
import {OutlineUnitBasicModel} from '@core/modules/rest/consent/response/outline-unit-basic.model';
import {UnitStatusEnum} from '@core/modules/rest/consent/enums/unit-status.enum';
import {ConsentRequestModel} from '@core/modules/rest/consent/request/consent-request.model';
import {SubmitConsentRequestModel} from '@core/modules/rest/consent/request/submit-consent-request.model';
import {GetMoreUnitsConsentRequestModel} from '@core/modules/rest/consent/request/get-more-units-consent-request.model';
import {CommentRequestModel} from '@core/modules/rest/consent/request/comment-request.model';
import {CommentBasicModel} from '@core/modules/rest/consent/response/comment-basic.model';
import {EditCommentRequestModel} from '@core/modules/rest/consent/request/edit-comment-request.model';
import {CommentAnswerRequestModel} from '@core/modules/rest/consent/request/comment-answer-request.model';
import {OutlineChapterUnitBasicModel} from '@core/modules/rest/consent/response/outline-chapter-unit-basic.model';
import {SubmitConsentOverviewRequestModel} from '@core/modules/rest/consent/request/submit-consent-overview-request.model';

export const ResetState = createAction(
    '[Consent] Reset state'
);

export const GetConsent = createAction(
    '[Consent] Get consent',
    props<{ consent: ConsentRequestModel }>()
);

export const GetConsentSuccess = createAction(
    '[Consent] Consent display success',
    props<{ consent: OutlineChapterUnitBasicModel[], currentUnitOrderId: number }>()
);

export const GetConsentDuration = createAction(
    '[Consent] Calculate consent duration',
    props<{ consent: ConsentRequestModel }>()
);

export const GetConsentDurationSuccess = createAction(
    '[Consent] Calculate consent duration success',
    props<{ duration: number }>()
);

export const MarkUnitStatus = createAction(
    '[Consent] Mark unit with adequate status',
    props<{ unitOrderId: number, status: UnitStatusEnum, viewDuration: number }>()
);

export const MarkSkippedUnitsStatuses = createAction(
    '[Consent] Mark multiple units with adequate status',
    props<{ unitsToMark: number[], initialUnitOrderIdList: number[], viewDuration: number }>()
);

export const LoadMoreUnits = createAction(
    '[Consent] Load more units for consent unit',
    props<{ request: GetMoreUnitsConsentRequestModel }>()
);

export const LoadMoreUnitsSuccess = createAction(
    '[Consent] Load more units for consent unit success',
    props<{ unitOrderId: number, units: OutlineUnitBasicModel[], viewDuration: number }>()
);

export const SubmitConsent = createAction(
    '[Consent] Submit consent',
    props<{ request: SubmitConsentRequestModel }>()
);

export const SubmitConsentSuccess = createAction(
    '[Consent] Submit consent success'
);

export const SubmitComment = createAction(
    '[Consent] Submit comment',
    props<{ request: CommentRequestModel }>()
);

export const SubmitCommentSuccess = createAction(
    '[Consent] Submit comment success',
    props<{ comment: CommentBasicModel }>()
);

export const GetConsentComments = createAction(
    '[Consent] Get all comments',
    props<{ consentId: string }>()
);

export const GetConsentCommentsSuccess = createAction(
    '[Consent] Get all comments success',
    props<{ comments: CommentBasicModel[] }>()
);

export const DeleteComment = createAction(
    '[Consent] Delete comment',
    props<{ consentId: string, commentId: string }>()
);

export const EditComment = createAction(
    '[Consent] Edit comment',
    props<{ request: EditCommentRequestModel }>()
);

export const EditCommentSuccess = createAction(
    '[Consent] Edit comment success',
    props<{ response: CommentBasicModel }>()
);

export const AnswerComment = createAction(
    '[Consent] Answer comment',
    props<{ request: CommentAnswerRequestModel }>()
);

export const SavePatientOverviewDuration = createAction(
    '[Consent] Save patient overview',
    props<{ consentId: string, request: SubmitConsentOverviewRequestModel }>()
);

export const FinishEducation = createAction(
    '[Consent] Finish patient education',
    props<{ consentId: string }>()
);

export const FinishEducationSuccess = createAction(
    '[Consent] Finish patient education success'
);


